<template>
    <div class="back">
        <el-card class="card">
            <div slot="header" style="text-align: center;">
                <span style="color:#ffffff;">非法调频监测系统</span>
            </div>
            <el-form ref="form" :model="form">
                <el-form-item>
                    <el-input placeholder="用户名" v-model="form.username">
                        <i slot="prefix" class="el-input__icon iconfont icon-gonghao"></i>
                    </el-input>
                </el-form-item>
                <el-form-item>
                    <el-input type="password" placeholder="密码" v-model="form.password">
                        <i slot="prefix" class="el-input__icon iconfont icon-unie604"></i>
                    </el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onSubmit" style="width:100%;">登录</el-button>
                </el-form-item>
            </el-form>
        </el-card>
    </div>

</template>

<script>
export default {
  name: "Login",
  data() {
    return {
      form: {
        username: "",
        password: ""
      }
    };
  },
  methods: {
    onSubmit() {
      let loading= this.$loading({
          background:"rgba(0, 0, 0, 0.8)",
          spinner:"el-icon-loading"
      })
      this.$ajax.get("/admin/login", {
          params: {
            name: this.form.username,
            password: this.form.password
          }
        })
        .then((response)=> {
          loading.close();
          if(response.data.success){
            localStorage.setItem('userInfo',JSON.stringify(response.data.userInfo));
            this.$router.push({ name: "Main" });
          }else{
            
             this.$message.error(response.data.msg);
          }
        })
        .catch((error)=> {
          console.log(error);
        });
    }
  }
};
</script>

<style scoped>
span {
  font: 20px Extra large;
}
.back {
  background: url(../assets/back.jpg);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 100%;
  height: 100%;
}
.card {
  position: relative;
  background: url(../assets/back.png);
  left: 40%;
  top: 25%;
  width: 20%;
  padding: 30px 40px 20px 40px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Login.vue